//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {setdevicenotify, setdevicenotifytype} from '../../api/device'

export default {
  name: 'device507',
  data () {
    return {
      showAdd: false,
      addText: '添加成功啦~',
      addWarn: false,
      warnText: '',
      deviceData: '',
      // 通知提醒
      showDisabled: false,
      openAlarm: false,
      // 通知方式
      resultWay: []
    }
  },
  created () {
    this.deviceData = this.$store.getters.get_child_obj
    if (this.deviceData.notify === 1) {
      this.openAlarm = true
    } else {
      this.openAlarm = false
    }
    let notifytype = this.deviceData.notifytype.split('')
    if (this.deviceData.phonedevicerole === 'admin') {
      this.showDisabled = false
    } else {
      this.showDisabled = true
    }
    console.log(100, this.showDisabled)
    this.resultWay = []
    if (notifytype[0] === '1') {
      this.resultWay.push('1')
    }
    if (notifytype[1] === '1') {
      this.resultWay.push('2')
    }
    if (notifytype[2] === '1') {
      this.resultWay.push('3')
    }
  },
  methods: {
    changeOpen () {
      this.changeNBDefence()
    },
    changeNBDefence () {
      let data = {did: this.deviceData.id, notify: 0}
      if (this.openAlarm) {
        data.notify = 1 // 开启
      } else {
        data.notify = 0 // 关闭
      }
      setdevicenotify(data).then(res => {
        if (res.code === 200) {
          this.showAdd = true
          this.addText = '成功'
          this.deviceData.notify = data.notify
        } else {
          this.addWarn = true
          this.warnText = '失败'
          this.openAlarm = !this.openAlarm
        }
        this.$store.commit('set_child_obj', this.deviceData)
      }).catch(() => {
        this.addWarn = true
        this.warnText = '布防失败'
        if (data.notify === 0) {
          this.deviceData.notify = 1
        } else {
          this.deviceData.notify = 0
        }
      })
    },
    // 通知方式
    changeWaySend () {
      console.log(this.resultWay)
      // console.log(this.resultWay, this.deviceData.notifytype)
      let way = '000'
      let notifytype = this.deviceData.notifytype
      for (let i = 0; i < this.resultWay.length; i++) {
        if (this.resultWay[i] === '1') {
          way = '1' + way.slice(1)
        } else if (this.resultWay[i] === '2') {
          way = way.slice(0, 1) + '1' + way.slice(2)
        } else if (this.resultWay[i] === '3') {
          way = way.slice(0, 2) + '1'
        }
      }
      notifytype = way + notifytype.slice(3)
      let data = {
        phone: this.$store.getters.get_user,
        did: this.deviceData.id,
        notifytype
      }
      setdevicenotifytype(data).then(res => {
        if (res.code === 200) {
          this.deviceData.notifytype = data.notifytype
          this.$toast.success('成功')
          this.$store.commit('set_child_obj', this.deviceData)
          // console.log('成功', this.deviceData.notifytype)
        } else {
          this.$toast.fail('失败')
          let wayArr = []
          let notifytype = this.deviceData.notifytype.split('')
          if (notifytype[0] === '1') {
            wayArr.push('1')
          }
          if (notifytype[1] === '1') {
            wayArr.push('2')
          }
          if (notifytype[2] === '1') {
            wayArr.push('3')
          }
          this.resultWay = wayArr
        }
      }).catch(() => {
        let wayArr = []
        let notifytype = this.deviceData.notifytype.split('')
        if (notifytype[0] === '1') {
          wayArr.push('1')
        }
        if (notifytype[1] === '1') {
          wayArr.push('2')
        }
        if (notifytype[2] === '1') {
          wayArr.push('3')
        }
        this.resultWay = wayArr
        this.$toast.fail('失败')
      })
      // console.log(way, notifytype, this.deviceData.notifytype)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/device507.vue